import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { marked } from 'marked';
import '../schemaform/formMarkdownEditor.css';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

const MARKDOWN_LINK_CLICK_CODE_BEHIND = {
    handlerSuffix: '_LinkClick',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Handle markdown link click; use context.Input.Href / Text / Title\n\t}`;
    },
};

export default defineComponent({
    name: 'markdown-dsgn',
    mixins: [DesignerRegistryMixin],
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        textStyles: function () {
            const styles = {
                whiteSpace: 'normal',
                display: 'block',
            };

            if (this.controlData.FontSize)
                styles['font-size'] = utils.resolveFontSize(this.controlData.FontSize);

            if (this.controlData.Color)
                styles.color = this.controlData.Color;
            else
                styles.color = '#444';

            return styles;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
        markdownHtml() {
            const raw = this.controlData.Markdown;
            if (!raw)
                return '';

            try {
                return marked.parse(String(raw), { async: false, gfm: true, breaks: true });
            }
            catch (e) {
                utils.warn('Markdown designer markdownHtml (marked) failed: ' + e);
                return '';
            }
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, MARKDOWN_LINK_CLICK_CODE_BEHIND);
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        const style = {
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            overflow: 'hidden',
            display: 'inline-block',
        };

        const preview = this.markdownHtml
            ? (
                <div
                    class={['form-markdown-editor-prose', 'tiptap']}
                    style={this.textStyles}
                    v-html={this.markdownHtml}
                />
            )
            : <span style={this.textStyles}>Empty</span>;

        return (
            <div style={style}>
                <span
                    class={{ 'designer-container': true, selected: this.selected$ }}
                    onClick={(e) => this.handleClick(e)}
                    onDblclick={(e) => this.handleDesignerDblClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }}></div>
                    {preview}
                </span>
            </div>
        );
    }
});
